<template>
    <div id="statistics-modal" class="no-click-stats" v-if="show">
        <div id="statistics-modal-container" class="no-click-stats">
            <div id="close-container" class="no-click-stats"><span class="close-button no-click-stats" @click="closeModal">X</span></div>
            <div class="documents-filter-container no-click-stats">
                <input type="text" class="form-control documents-search no-click-stats" v-model="filter" placeholder="Filter" @keydown="$event.stopImmediatePropagation()">
                <button class="btn btn-primary no-click-stats download-button" @click="downloadExcel">Download (<i>{{ media_name }}.xlsx</i>)</button>
                <div class="no-click-stats info-message-container">
                        <button class="btn btn-secondary no-click-stats" @click="sendMessage" :disabled="numberOfMessages > 0 ? false : true">
                            <span>{{ trans('lms.SendMessage') }}</span>  <span class="badge badge-primary">{{ numberOfMessages }}</span>
                            <div v-if="loading" class="spinner-border text-primary no-click-stats" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </button>
                </div>
                <div id="message-container no-click-stats" v-if="message">
                    <p>{{message}}</p>
                </div>
            </div>
            <div class="table-wrapper">
                <datatable :columns="columns" :data="rows" class="documents-table no-click-stats" :per-page="10" :filter="filter">
                    <template slot-scope="{ row }">
                        <tr>
                            <td>{{ row.id }}</td>
                            <td>{{ row.first_name }}</td>
                            <td>{{ row.last_name }}</td>
                            <td>{{ row.updated_at }}</td>
                        </tr>
                    </template>
                </datatable>
                <datatable-pager v-model="page" class="datatable-pagination" type="short"></datatable-pager>
            </div>
            
        </div>
        
    </div>
</template>
<script>
 
export default {
  props: ["files","show","media_id", "media_name", "translations"],
  data() {
    return {
        filter:  '',
        columns: [
            {label: this.translations.Id, field: this.translations.Id, align: 'right', headerClass: 'th-cell no-click-stats disable-child-clicks'},
            {label: this.translations.FirstName, field: 'first_name', align: 'left', headerClass: 'th-cell no-click-stats disable-child-clicks'},
            {label: this.translations.LastName, field: 'last_name', align: 'left', headerClass: 'th-cell no-click-stats disable-child-clicks'},
            {label: this.translations.LastViewed, field: 'updated_at', align: 'left', headerClass: 'th-cell no-click-stats disable-child-clicks'}
        ],
        page: 1,
        message: "",
        loading: false,
    };
  },
  computed: {
      rows(){
        return this.files;
      },
      fields(){
        let id = this.translations.Id;
        let firstName = this.translations.FirstName;
        let lastName = this.translations.LastName;
        let lastViewed = this.translations.LastViewed;

        return {
            [id]: 'id',
            [firstName]: 'first_name',
            [lastName]: 'last_name',
            [lastViewed]: 'updated_at'
        }
      },
      numberOfMessages(){
          let counter = 0;
          for(let i=0;i<this.files.length;i++){
              if(this.files[i].updated_at == null){
                counter++;
              }
          }
          return counter;
      }
  },
  methods:{
      closeModal(){
          this.show = false;
          this.$emit('modalClosed')
      },
      sendMessage(){
        let user_ids = this.files.map(function(a) {
            if(a.updated_at == null){
                return a.id;
                }
            else{
                return null;
                }
            }); // get user_ids from this.files array
        this.loading = true;
        let filtered_ids = user_ids.filter(function(el){
            return el != null;
        });
        axios({
            method: 'post',
            url: '/message/create/recipients',
            data: {
                _token: this.csrf,
                users: filtered_ids,
                media_id: this.media_id
            }
        }).then((response) => {
            this.loading = true;
            if(response.data.redirect){
                localStorage.setItem('users', response.data.users);
                
                window.location = response.data.redirect;
            }else{
                this.message = response.data.message;
                setTimeout(()=>{this.message = ''}, 10000);
            }
            
        });
      },
      downloadExcel(){

        window.newSheet(this.media_name, [this.translations.Id, this.translations.FirstName, this.translations.LastName, this.translations.LastViewed], this.rows);

      }
  }
};
</script>
<style>
    @keyframes spinner-border {
        to { transform: rotate(360deg); }
    }
    .disable-child-clicks >*{
        pointer-events: none;
    }
    .spinner-border {
        top: 2px;
        position: relative;
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        border: .25em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        -webkit-animation: spinner-border .75s linear infinite;
        animation: spinner-border .75s linear infinite;
    }
    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0,0,0,0);
        white-space: nowrap;
        border: 0;
    }
    

    #statistics-modal{
        width: 100vw;
        height: 100vh;
        position: fixed;
        top:0;
        left: 0;
        z-index: 10000;
        background: rgba(0,0,0,0.7);
    }
    #statistics-modal-container{
        width: 80%;
        max-height: 80%;
        height: auto;
        margin: 100px auto;
        border: 1px solid lightgrey;
        background: white;
        border-radius: 4px;
        padding: 10px;
    }
    #statistics-list{
        display: flex;
        flex-direction: column;
    }
    #message-container{
        position: absolute;
        top: 105px;
        left: 50%;
        transform: translateX(-50%);
        max-width: 100%;
    }
    #message-container > p{
        width: auto;
    }
    #close-container{
        position: relative;
        height: 25px;
        float: right;
    }
    .close-button{
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
        display: inline-block;
        width: 35px;
        height: 35px;
        /* font-size: 18px; */
        font-size: 26px !important;
        margin-right: 0 !important;
    }
    .documents-filter-container{
        /* max-width: 200px; */
        display: flex;
        align-items: center;
    }
    .documents-search{
        max-width: 200px;
        margin-right: 15px;
    }
    .documents-table{
        width: 100%;
        max-height: 100%;
        margin-bottom: 10px;
        background-color: white;
    }
    .th-cell{
        padding: 10px;
        border-bottom: 1px solid grey;
        text-align: left !important;
    }

    .documents-pagination{
        display: flex;
        padding-left: 0;
        margin: 22px 0;
        border-radius: 4px;
        align-items: center;
        justify-content: center;
    }
    .documents-active{
        display: inline-block;
        width: 25px;
        margin-right: 4px;
    }
    .info-message-container{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .info-message{
        margin-left: 25px;
        font-size: initial;
    }
    .download-button{
        max-width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 15px;
    }
    .table-wrapper{
        width: 100%;
        overflow-x: auto;
        margin-top: 20px;
    }
    .documents-table tbody tr td{
        padding: 12px 6px;
        padding: 10px;
        border-bottom: 1px solid lightgrey;
    }
    .datatable-pagination ul{
        padding-left: 0;
    }
    .datatable-pagination ul li{
        padding: 10px;
    }
    .datatable-pagination ul li.active{
        padding:0;
        padding-right: 5px;
    }
    @media screen and (max-width: 930px){
        .documents-filter-container{
            flex-wrap: wrap;
            justify-content: center;
        }
        .documents-search{
            max-width: 90%;
            margin-bottom: 20px;
            margin-right: 50px;
        }
    }
    @media screen and (max-width: 604px){
        .download-button{
            margin-bottom: 10px;
            margin-right: 0;
            max-width: 100%;
            width: 100%;
        }
        .info-message-container{
            width: 100%;
        }
        .documents-filter-container .btn.btn-secondary{
            width: 100%;
            max-width: 100%;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/documentsstatistics.vue